var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This function generates the five statuses from a single CRUD action.
// For instance, you'd probably pass "CREATE", "READ", "UPDATE", or "DELETE"
// as `crudAction`.
//
// These are deprecated in favor of the simpler alternatives listed in
// `./action-types`. Those work the _exact_ same way. Because there are
// fewer of them, they should be easier to use.
var mapConstant = function mapConstant(crudAction) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, crudAction + '_RESOURCES_PENDING', crudAction + '_RESOURCES_PENDING'), _defineProperty(_ref, crudAction + '_RESOURCES_SUCCEEDED', crudAction + '_RESOURCES_SUCCEEDED'), _defineProperty(_ref, crudAction + '_RESOURCES_FAILED', crudAction + '_RESOURCES_FAILED'), _defineProperty(_ref, crudAction + '_RESOURCES_IDLE', crudAction + '_RESOURCES_IDLE'), _ref;
};

var createTypes = mapConstant('CREATE');
var readTypes = mapConstant('READ');
var updateTypes = mapConstant('UPDATE');
var deleteTypes = mapConstant('DELETE');

export default _extends({}, createTypes, readTypes, updateTypes, deleteTypes);